import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { CorporateConfig } from 'src/app/corporate.config';
import { HelpersService } from 'src/app/helpers/helpers.service';
import { Applicant } from '../../models/applicant.model';
import { AccountService } from '../../services/account.service';
import { AuthenticationService } from '../../services/authentication.service';
import { filter, switchMap } from 'rxjs';
import { TenantService } from 'src/app/services/tenant.service';
import { AppConfig } from 'src/app/app.config';
import { Router } from '@angular/router';

@Component({
    selector: 'applications',
    templateUrl: './applications.component.html',
    styleUrls: ['./applications.component.css']
})
export class ApplicationsComponent implements OnInit {

    public applicantList: Applicant[] = [];
    public hasApplications = false;
    public applicationsLoaded = false;
    tenantName: string = '';

    private readonly isAccountApplicationMode = AppConfig.getAccountMode;
    private readonly accountModeUrl = AppConfig.getAccountModeUrl;

    constructor(
        private accountService: AccountService,
        private authenticationService: AuthenticationService,
        private title: Title,
        private helperService: HelpersService,
        private tenantService: TenantService,
                private router : Router
    ) {
        this.title.setTitle(this.helperService.getPageContent(CorporateConfig.applicationsTitle));
    }

    ngOnInit(): void {
        this.authenticationService.isUserLoggedin.pipe(
            filter(loggedIn => loggedIn),
            switchMap(() => this.accountService.applicationsMade())
        ).subscribe(res => this.setApplicants(res));
        this.tenantService.getTenantDetails().subscribe({
            next: tenant => this.tenantName = tenant.TenantDisplayName
        });
    }

    downloadCv(guid: string) {
        this.accountService.downloadDocumentByGuid(guid, 'Candidate.CvDownload');
    }

    downloadAF(guid: string): void {
        this.accountService.downloadDocumentByGuid(guid, 'DownloadCandidateApplicationForm');
    }

    downloadCoverLetter(guid: string): void {
        this.accountService.downloadDocumentByGuid(guid, 'Candidate.CoverLetterDownload');
    }

    navigateToJobDetails(jobTitle: string, advertId: string) {
        let jobDetailsUrl: string = `/job/${jobTitle}/${advertId}`;
        this.isAccountApplicationMode ?
            document.location.href = this.accountModeUrl + `job/${jobTitle}/${advertId}` :
            this.router.navigate([jobDetailsUrl]);
    }

    private setApplicants(applicants: Applicant[]): void {
        this.applicantList = applicants;
        this.hasApplications = (this.applicantList != null && this.applicantList.length > 0);
        this.applicationsLoaded = true;
    }
}
